<template>
  <v-card flat outlined :class="{'v-card--only-quote': product.attributes.onlyQuote}">
    <a class="no-decoration text-dark h-100 d-flex flex-column " :href="linkToProduct(product)">
      <v-img
          v-if="product.attributes.mainImageUrl"
          :src="product.attributes.mainImageUrl"
      />

      <v-card-title class="subtitle-2 justify-content-between position-relative">
        <div  class="products-grid__vendor-name">
          {{ product.attributes.vendorName }}
        </div>
        <div  class="products-grid__name">
          {{ product.attributes.name }}
        </div>
      </v-card-title>
      <div class="products-grid__info-container">
        <v-card-text v-if="!product.attributes.onlyQuote" :class="{'products-grid__price-container': true, 'mb-0 pb-2': userLoggedIn }">
              <span
                  :class="{'products-grid__retail-price': true, 'products-grid__retail-price--disabled': userLoggedIn }">
                {{ product.attributes.retailPrice > 0 ? product.attributes.displayRetailPrice : product.attributes.displayPrice }}
              </span>
          <span class="font-weight-bold retail-price-desc">{{ $t('searchableProducts.products.retail_price') }}</span>
        </v-card-text>
        <v-card-text class="pt-0 pb-0" v-if="userLoggedIn && !product.attributes.onlyQuote">
          <div v-if="product.attributes.discountedPrice"
               class="products-grid__retail-price">
            {{ product.attributes.displayDiscountedPrice }}
          </div>
          <div class="products-grid__price-container products-grid__price-container--wholesale" v-else>
                  <span class="products-grid__retail-price">
                      {{ product.attributes.displayPrice }}
                  </span>
            <span class="font-weight-bold wholesale-price-desc">
                    {{ $t('searchableProducts.products.wholesale_price') }}
                  </span>
          </div>
        </v-card-text>
        <a v-else class="products-grid__see-wholesale-price" :href="userLoggedIn ? linkToProduct(product) : '/signup?user_type=client'">
          {{ !product.attributes.onlyQuote ? $t('searchableProducts.products.see_wholesale_price') : $t('searchableProducts.products.get_quote') }}
        </a>
      </div>
    </a>
  </v-card>
</template>
<script>
export default {
  props: ['product'],
  data: () => ({
    userLoggedIn: false,
  }),
  created() {
    this.userLoggedIn = window.userLoggedIn;
  },
  methods: {
    linkToProduct(product) {
      return '/products/' + product.attributes.slug
    },
  }
}
</script>

